import { render, staticRenderFns } from "./DetailsDrawer.vue?vue&type=template&id=4f594898&scoped=true&"
import script from "./DetailsDrawer.vue?vue&type=script&lang=ts&"
export * from "./DetailsDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsDrawer.vue?vue&type=style&index=0&id=4f594898&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f594898",
  null
  
)

export default component.exports